import type { ApiFileUploadTypes } from 'api/types/ApiFileUploadTypes';
import { FilePicker } from 'components/FilePicker/FilePicker';

import { Field } from './Field/Field';

type Props = {
  'aria-label'?: string;
  'data-qa-id'?: string;
  accept?: string;
  description?: string;
  disabled?: boolean;
  downloadAttachment?: boolean;
  extraAnalyticsData?: Record<string, unknown>;
  fileType?: ApiFileUploadTypes;
  maxSize?: number; // in MB
  hideRemove?: boolean;
  label?: string;
  large?: boolean;
  message?: string;
  header?: string;
  name: string;
  onError?: (error: Error) => void;
  onUpdateValue?: (fileId: string | undefined) => void;
  showDate?: boolean;
};

export function FilePickerField({
  'data-qa-id': qaId,
  description,
  downloadAttachment,
  extraAnalyticsData,
  fileType = 'CMS_UPLOAD',
  maxSize = 10,
  hideRemove,
  label,
  large,
  header,
  name,
  onError,
  onUpdateValue,
  ...props
}: Props) {
  return (
    <Field
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      name={name}
      label={label}
      description={description}
      inputProps={props}
      renderInput={({ value, qaId: autoQaId, updateValue }) => (
        <FilePicker
          downloadAttachment={downloadAttachment}
          extraAnalyticsData={extraAnalyticsData}
          hideRemove={hideRemove}
          fileId={value}
          fileType={fileType}
          data-qa-id={qaId || autoQaId}
          onChange={(e) => {
            if (onUpdateValue) {
              onUpdateValue(e);
            } else {
              updateValue(e);
            }
          }}
          onError={onError}
          name={name}
          large={large}
          maxSize={maxSize}
          header={header}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
        />
      )}
    />
  );
}
